import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../context/useAuth';

const Login = () => {
  const { signIn, mockSignIn, mockAdminSignIn, isAuthenticated } = useAuth();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const wasSignedOut = searchParams.get('signedOut') === 'true';
  
  // Check if user is already authenticated on component mount and on every render
  useEffect(() => {
    if (isAuthenticated) {
      const redirectPath = sessionStorage.getItem('redirectTo') || '/';
      console.log('User already authenticated, redirecting to:', redirectPath);
      navigate(redirectPath, { replace: true });
      sessionStorage.removeItem('redirectTo');
    }
  }, [isAuthenticated, navigate]);

  const handleMockAdminSignIn = async () => {
    if (!mockAdminSignIn) return;
    
    try {
      setLoading(true);
      await mockAdminSignIn();
    } catch (error) {
      console.error('Error signing in as mock admin:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      {wasSignedOut && (
        <div className="p-4 mb-4 text-sm text-blue-700 bg-blue-100 rounded-lg" role="alert">
          You have been successfully signed out
        </div>
      )}
      <p className="text-center">Sign in to access your schedules</p>
      <button
        onClick={signIn}
        disabled={loading}
        className="w-full px-4 py-2 text-white bg-primary rounded hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-primary-light disabled:opacity-50"
      >
        Sign in with Microsoft
      </button>
      {process.env.NODE_ENV === 'development' && mockSignIn && mockAdminSignIn && (
        <>
          <button
            onClick={mockSignIn}
            disabled={loading}
            className="w-full px-4 py-2 text-white bg-green-600 rounded hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-300 disabled:opacity-50"
          >
            Mock User Sign In (Dev Only)
          </button>
          <button
            onClick={handleMockAdminSignIn}
            disabled={loading}
            className="w-full px-4 py-2 text-white bg-purple-600 rounded hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-300 disabled:opacity-50"
          >
            Mock Admin Sign In (Dev Only)
          </button>
        </>
      )}
    </div>
  );
};

export default Login; 